import axios from "axios";

let API_URL = "https://www.armpay.pro/api";
if (process.env.NODE_ENV === "production")
    API_URL = `${window.location.origin}/api`;

// axios.defaults.withCredentials = true;
export const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

export interface Data<T> {
    errorCode: number,
    errorText: string,
    data: T[]
}

export interface OResult {
    result: number | boolean | null,
}
